module.exports = __webpack_public_path__ + "static/media/bookalike.08c3c1de.svg";